export default "__VITE_ASSET__BmojGZM3__"